module.exports = __webpack_public_path__ + "img/M7-banner.f53046a1.png";